var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRepository(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m3 2.75c0-1.51878 1.23122-2.75 2.75-2.75h14.5c.4142 0 .75.335786.75.75v20.5c0 .4142-.3358.75-.75.75h-6c-.4142 0-.75-.3358-.75-.75s.3358-.75.75-.75h5.25v-4h-13.5c-.82843 0-1.5.6716-1.5 1.5v.75c0 .7164.43064 1.334 1.05028 1.6047.37956.1659.55282.608.38698.9876-.16583.3795-.60797.5528-.98754.3869-1.14627-.5008-1.94972-1.6453-1.94972-2.9792zm16.5-1.25v13.5h-13.5c-.54643 0-1.05874.1461-1.5.4013v-12.6513c0-.69036.55964-1.25 1.25-1.25z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7 18.25c0-.1381.11193-.25.25-.25h5c.1381 0 .25.1119.25.25v5.0091c0 .2043-.2318.3223-.397.2021l-2.20596-1.6043c-.08766-.0637-.20642-.0637-.29408 0l-2.20592 1.6043c-.16524.1202-.39704.0022-.39704-.2021z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepository);
export default __webpack_public_path__ + "static/media/repository.e61c7df22389c99f551b6f8b39c0cfd0.svg";
export { ForwardRef as ReactComponent };